import { PayBand } from 'libs/end-to-end/src/datasets';
import { z } from 'zod';
import { TestCount } from 'libs/end-to-end/src/tests-utils';

export const PayCorrectionResult = z
  .object({
    employeeid: z.string(),
    job_title: z.string().nullable(),
    job_level: z.string(),
    gender: z.string().nullable(),
    race: z.string().nullable(),
    long_perf_review: z.number().nullable(),
    long_experience: z.number().nullable(),
    salary: z.number(),
    recommended_salary: z.number(),
    pct_pay_gap: z.number(),
    underpaid: z.number(),
  })
  .describe('PayCorrectionResult');

export type PayCorrectionResult = z.infer<typeof PayCorrectionResult>;

export const PayCorrectionSummaryItem = z
  .object({
    budget_needed: z.number(),
    num_employees: z.number(),
    num_underpaid: z.number(),
    avg_pay_gap: z.number(),
    avg_pct_pay_gap: z.number(),
    cumulative_pct_pay_gap: z.number(),
    test_count: TestCount,
  })
  .describe('PayCorrectionSummaryItem');

export type PayCorrectionSummaryItem = z.infer<typeof PayCorrectionSummaryItem>;

export const CorrectionResultPayCorrectionSummary = z
  .object({
    overall: PayCorrectionSummaryItem,
  })
  .describe('CorrectionResultPayCorrectionSummary');

export type CorrectionResultPayCorrectionSummary = z.infer<
  typeof CorrectionResultPayCorrectionSummary
>;

export const BaseLevelPayCorrectionResult = z
  .object({
    pay_correction_summary: CorrectionResultPayCorrectionSummary,
  })
  .describe('BaseLevelPayCorrectionResult');

export type BaseLevelPayCorrectionResult = z.infer<
  typeof BaseLevelPayCorrectionResult
>;

export const LevelPayCorrectionResultLevelType = z
  .enum(['job_level', 'department'])
  .describe('LevelPayCorrectionResultLevelType');

export const LevelPayCorrectionResult = BaseLevelPayCorrectionResult.merge(
  z.object({
    level_name: z.string(),
    level_type: LevelPayCorrectionResultLevelType,
  }),
).describe('LevelPayCorrectionResult');

export type LevelPayCorrectionResult = z.infer<typeof LevelPayCorrectionResult>;

export const OverallPayCorrectionResults = z
  .object({})
  .describe('OverallPayCorrectionResults');

export type OverallPayCorrectionResults = z.infer<
  typeof OverallPayCorrectionResults
>;

export const PayCorrectionOutput = z
  .object({
    level_pay_correction_results: z.array(LevelPayCorrectionResult),
    overall_pay_correction_results: CorrectionResultPayCorrectionSummary,
    pay_correction_results: z.array(PayCorrectionResult),
    internal_pay_benchmarking_pay_band: PayBand.nullable(),
  })
  .describe('PayCorrectionOutput');

export type PayCorrectionOutput = z.infer<typeof PayCorrectionOutput>;

export const PayCorrectionExtras = z
  .object({
    adjustedSalaries: z.record(z.string(), z.number()),
  })
  .describe('PayCorrectionExtras');

export type PayCorrectionExtras = z.infer<typeof PayCorrectionExtras>;
